export default {
    LOADING: 'LOADING',
    NOT_LOADING: 'NOT_LOADING',
};
